import { useCallback } from 'react';

import { SplashScreen } from '@capacitor/splash-screen';
import { useContextSelector } from 'use-context-selector';
import { Capacitor } from '@capacitor/core';

import { SplashProviderContext } from '../../contexts/SplashProviderContext';

export const useSplash = () => {
  const handleOnHide = useContextSelector(
    SplashProviderContext,
    ({ hide }) => hide
  );

  const hide = useCallback(async () => {
    if (Capacitor.isNativePlatform()) {
      await SplashScreen.hide();
    }
    handleOnHide();
  }, [handleOnHide]);

  return { hide };
};
